<ng-container *ngIf="summaryData$ | async as summary">
  <div class="dialog-header">
    <p class="title" [ngClass]="summary.type">
      {{ summary.title }} ({{ summary.quantity }})
    </p>

    <p *ngIf="summary.subtitle" class="subtitle">
      {{ summary.subtitle }}
    </p>

    <p *ngIf="summary.additionalNote" class="note">
      {{ summary.additionalNote }}
    </p>

    <p class="total-amount">
      {{ summary.totalAmount | money: summary.currencyCode:locale }}
    </p>
  </div>

  <div
    *ngIf="!(showEmptyState$ | async); else emptyState"
    class="dialog-content"
    #scrollElement
    (scroll)="scrollTrackingHandler($event)"
  >
    <div
      *ngIf="summaryDataItems$ | async as summaryDataItems"
      class="summary-list-items-wrapper"
    >
      <div
        *ngFor="let item of summaryDataItems"
        class="summary-list-item"
        (click)="handleDeeplink(item.deeplink)"
      >
        <p class="item-title">{{ item.title }} ({{ item.quantity }})</p>

        <p class="amount">
          {{ item.total_amount | money: summary.currencyCode:locale }}
        </p>

        <i2g-icon
          *ngIf="item.deeplink"
          name="chevron-right"
          size="small"
          class="chevron-icon"
        ></i2g-icon>
      </div>
    </div>

    <p
      *ngIf="summary.allOtherSummary as otherSummary"
      class="other-items-summary"
    >
      {{
        'HOME.INSIGHTS_HUB.OVERDUE_INVOICES_EXPANDED_VIEW.DIALOG_FOOTER'
          | translate
            : {
                quantity: otherSummary.quantity,
                amount:
                  otherSummary.totalAmount | money: summary.currencyCode:locale
              }
      }}
    </p>

    <i2g-router-link
      *ngIf="dialogCtaRoute$ | async as ctaRoute"
      buttonStyle="tertiary"
      class="dialog-cta"
      [route]="ctaRoute.route"
      [navigationExtras]="ctaRoute.navigationExtras"
      [alignment]="alignmentEnum.center"
      [label]="summary.cta.title"
      i2gTrackable
      [trackingObject]="trackingObject"
      [trackingAction]="ctaRoute.trackingAction"
      [trackingAdditionalProperties]="ctaRoute.trackingAdditionalProperties"
      (click)="closeDialog()"
    >
    </i2g-router-link>
  </div>
</ng-container>

<ng-template #emptyState>
  <div class="dialog-content empty-state-wrapper">
    <i2g-icon
      name="invoices-empty-state"
      size="custom"
      class="empty-state-icon"
    ></i2g-icon>

    <p class="empty-state-message">
      {{
        'HOME.INSIGHTS_HUB.OVERDUE_INVOICES_EXPANDED_VIEW.EMPTY_STATE_MESSAGE'
          | translate
      }}
    </p>

    <i2g-router-link
      *ngIf="emptyStateCta$ | async as emptyStateCta"
      buttonStyle="default"
      class="empty-state-cta"
      [label]="emptyStateCta.label | translate"
      [route]="emptyStateCta.route"
      [navigationExtras]="emptyStateCta.navigationExtras"
      i2gTrackable
      [trackingObject]="trackingObject"
      [trackingAction]="emptyStateCta.trackingAction"
      [trackingAdditionalProperties]="
        emptyStateCta.trackingAdditionalProperties
      "
      (click)="closeDialog()"
    ></i2g-router-link>
  </div>
</ng-template>
